const FUELS = {
    'Petrol': 'Benzyna',
}

const STATUS = {
    ok: 'ok',
    warn: 'warn',
    expired: 'expired',
    unknown: 'unknown',
}

const STATUSES = {
    ok: { t: 'ważny', icon: 'done', color: 'green' },
    warn: { t: 'kończy się', icon: 'priority_high', color: 'yellow' },
    expired: { t: 'po terminie', icon: 'close', color: 'red' },
    unknown: { t: 'brak danych', icon: 'question_mark', color: 'blue' },
}

export {
    FUELS,
    STATUS,
    STATUSES,
}